<template>
    <transition name="fade">
        <div class="ui-update-tips" v-show="showUpdateTips">
            <div class="update-wrapper">
                <div class="title">
                    <i class="point"></i>
                    <span class="txt">新版本更新</span>
                    <i class="point"></i>
                </div>
                <p class="content">
                    当前版本过低，不支持此功能， 请下载最新版南方＋客户端
                </p>
                <p class="btn btn-red" @click="toDownload">前往下载</p>
                <p class="btn btn-white" @click="handleExit">暂不下载</p>
            </div>
        </div>
    </transition>
</template>

<script>
import config from '../../../../config'
export default {
  name: 'nfUpdateTips',
  props: {
    showUpdateTips: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toDownload() {
      let osInfo = this.getSystem()
      if (osInfo.ios) {
        window.location.href =
          'https://itunes.apple.com/cn/app/nan-fangplus/id1041891085?mt=8'
      } else if (osInfo.android) {
        window.location.href = config.downloadGuid
      }
    },
    handleExit(e) {
      this.$emit('exit', e)
    },
    getSystem() {
      var u = navigator.userAgent
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // 是否为ios设备
      var isPC = typeof window.orientation === 'undefined' // 是否为PC端
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // 是否为android端
      var isWx = u.toLocaleLowerCase().indexOf('micromessenger') > -1 // 判断是否为微信浏览器
      var isPhoneX =
        /iphone/gi.test(navigator.userAgent) &&
        (screen.height >= 812 && screen.width >= 375)

      let os = {
        ios: isIOS,
        pc: isPC,
        android: isAndroid,
        isWx: isWx,
        isPhoneX: isPhoneX
      }
      return os
    }
  }
}
</script>

<style scoped>
.ui-update-tips {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
}
.update-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 5.5rem;
  height: 5.84rem;
  border-radius: 0.2rem;
  background: #ffffff url('./images/pop_head_bg.png') no-repeat center top;
  background-size: 100% auto;
  overflow: hidden;
  padding: 0 0.52rem;
  box-sizing: border-box;
}
.title {
  margin-top: 0.56rem;
  color: #ffffff;
  font-family: PingFangSC-Medium;
  font-size: 0.4rem;
  font-weight: 600;
  line-height: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.title .point {
  width: 0.08rem;
  height: 0.08rem;
  border-radius: 50%;
  margin: 0 0.12rem;
  background: #ffffff;
}
.content {
  margin-top: 1rem;
  color: #333333;
  font-family: PingFangSC-Regular;
  line-height: 0.48rem;
  font-size: 0.308rem;
  text-align: justify;
}
.btn.btn-red {
  margin-top: 0.48rem;
  color: #ffffff;
  font-size: 0.32rem;
  border: none;
}
.btn {
  display: inline-block;
  border: 0.02rem solid #f64e45;
  width: 100%;
  height: 0.8rem;
  border-radius: 0.39rem;
  background: linear-gradient(to right, #ff6944, #f64e45);
  font-size: 0.32rem;
  font-family: PingFangSC-Regular;
  outline: none;
  text-align: center;
  line-height: 0.8rem;
}
.btn.btn-white {
  margin-top: 0.28rem;
  background: #ffffff;
  color: #f64e45;
  margin-bottom: 0.56rem;
}
.btn-white:active {
  background: #f2f2f2;
}
.btn-red:active {
  background: linear-gradient(to right, #ff7d5d, #fd6b63);
}

.fade-enter-to,
.fade-leave {
  opacity: 1;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s;
}
</style>


